import React from 'react';
import { ColumnType } from 'antd/lib/table';
import _ from 'lodash';
import { DataType, MealType } from './IntakeTableComponent';

export const intakeTableColumns = ({
  meal: () : ColumnType<DataType> => ({
    title: 'Meal',
    dataIndex: 'meal',
    render: (obj: MealType) => (
      <div>
        <div className="default">
          {_.capitalize(obj.name || '')}
        </div>
        <div className="second">
          {obj.time}
        </div>
      </div>
    ),
  }),
  foodTypeAmount: (): ColumnType<DataType> => ({
    title: 'Food Type & Amount',
    dataIndex: 'foodTypeAmount',
  }),
  mealFreq: (): ColumnType<DataType> => ({
    title: 'Frequency',
    dataIndex: 'mealFreq',
    align: 'center',
  }),
  skipFreq: (): ColumnType<DataType> => ({
    title: 'Skip',
    dataIndex: 'skipFreq',
    align: 'center',
  }),
});
